
import Tooltip from '@mui/material/Tooltip';

function PostTitleElement({post = {}, title, link, tooltip = ''}){
    const style = {
        fontWeight: 'bold',
        textDecoration: 'none'
    };
    const tooltipText = tooltip || post.title || '';
    const href = link || post.full_uri || '#';
    const label = title || post.title || '';

    return (
        <Tooltip title={tooltipText} arrow>
            <a rel="noreferrer" style={style} href={href} target="_blank">{label}</a>
        </Tooltip>
    );
}
export default PostTitleElement;